// Customizable Area Start
import React from "react";
import { Typography } from "@mui/material";

const MessageListView = ({ messages, formatAMPM }) => {
  return (
    <div>
      {messages?.map((message, i) => {
        const { senderName, message: text, timestamp } = message;
        return (
          <div style={webStyle.messageBox} key={i}>
            <Typography
              variant="subtitle1"
              style={webStyle.senderName}
              data-testid="senderName"
            >
              {senderName}
            </Typography>
            <h3 style={webStyle.messageText} data-testid="messageText">
              {text}
            </h3>
            <Typography variant="subtitle2" style={webStyle.time}>
              {formatAMPM(new Date(timestamp))}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

const webStyle = {
  messageBox: {
    margin: 8,
    backgroundColor: "#2196f3",
    borderRadius: 8,
    overflow: "hidden",
    padding: 8,
    color: "#fff",
  },
  senderName: {
    margin: 0,
    padding: 0,
    fontStyle: "italic",
  },
  messageText: {
    margin: 0,
    padding: 0,
    marginTop: 4,
  },
  time: {
    margin: 0,
    padding: 0,
    opacity: 0.6,
    marginTop: 4,
  },
};

export default MessageListView;
// Customizable Area End
